import { Component } from '@angular/core';


@Component({
  selector: 'mui-modal-footer',
  template: '<ng-content></ng-content>',
  host: {
    'class': 'mui-modal__footer'
  }
  // Do not do that! Property is set by the class .mui-modal__footer
  // styles: [':host {display: block}']
})
export class MuiModalFooter {}
